import axios from 'axios';
import {getAuthConfig} from '../utils/apiConfig';

export async function productFirstScan(payload) {
  const {url, headers} = await getAuthConfig();
  const {data} = await axios.post(
    `${url}/scan_pack/product_first_scan.json`,
    payload,
    {headers}
  );
  return data;
}

export async function scanToTote(payload) {
  const {url, headers} = await getAuthConfig();
  const {data} = await axios.post(
    `${url}/scan_pack/scan_to_tote.json`,
    payload,
    {headers}
  );
  return data;
}

export async function assignUserToteSet(input) {
  const {url, headers} = await getAuthConfig();
  const {data} = await axios.post(
    `${url}/scan_pack/assign_user_tote_set.json`,
    {input},
    {headers}
  );
  return data;
}

export async function addOrderNote(orderId, note) {
  const {url, headers} = await getAuthConfig();
  const {data} = await axios.post(
    `${url}/scan_pack/add_note.json`,
    {id: orderId, note},
    {headers}
  );
  return data;
}

export async function clearOrderTote(orderId) {
  const {url, headers} = await getAuthConfig();
  const {data} = await axios.get(
    `${url}/orders/${orderId}/clear_order_tote.json`,
    {headers}
  );
  return data;
}

export async function removeItemFromOrder(orderItemId) {
  const {url, headers} = await getAuthConfig();
  const {data} = await axios.post(
    `${url}/orders/remove_item_from_order.json`,
    {orderitem: [orderItemId], on_ex: 'on GPX'},
    {headers}
  );
  return data;
}

export async function fetchShipment(storeId, orderId) {
  const {url, headers} = await getAuthConfig();
  const {data} = await axios.post(
    `${url}/scan_pack/get_shipment.json`,
    {store_id: storeId, order_id: orderId},
    {headers}
  );
  return data;
}
